import React from 'react';
import { Outlet } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './Header';
import Footer from './Footer';

const Layout: React.FC = () => {
  return (
    <HelmetProvider>
      <div className="page-layout">
        <div className="bg-ambient-art" aria-hidden="true" />
        <Header />
        <main className="main-content">
          <Outlet />
        </main>
        <Footer />
      </div>
    </HelmetProvider>
  );
};

export default Layout;
